export default {
  id: '4',
  title: '居家主动康复指导服务',
  createTime: '2025-03-22 10:00:00',
  content: `![img](https://cdn.keihong.tech/img/20250422161417614.png)

## 1个月居家远程康复指导

专业康复指导，在家轻松完成。适合有轻微病痛，追求便捷康复的人士。

1） **专业视频问诊**: 每月2次线上视频指导，每次20分钟深度交流。
2） **个性化训练**: 量身定制2套居家训练方案，科学循序渐进。
3） **便捷操作**: 通过手机或电视投屏，随时打开远程康复小程序。
4） **轻松追踪**: 实时记录康复进度，专家及时调整训练方案。
5） **无障碍沟通**: 康复过程中遇到问题，专家及时解答指导。

![img](https://cdn.keihong.tech/img/20250422161417397.png)

## 3个月居家远程康复指导

适合需要居家长期康复的人士。

1） **长周期专业陪伴**: 全程90天精细化康复指导，解决长期健康问题。
2） **专业视频问诊**: 每月2次线上视频交流，每次20分钟深度指导。
3） **个性化训练方案**: 量身定制6套循序渐进的居家训练计划，系统改善健康状况。
4） **双重使用便利**: 手机小程序随时使用，或选配智能康复仪（免费使用，仅收押金）。

咨询电话：18520535303

添加二维码：

![img](https://cdn.keihong.tech/img/20250422161417355.png)`
}
